import { boolean, defaulted, literal, object, union } from "superstruct";

import { REVIEWER_NAME_DISPLAY_FORMAT } from "../constants";
import ReviewsSortingOptionsSchema from "./ReviewsSortingOptionsSchema";

const ReviewsStorefrontValuesSettingsSchema = object({
    canUseTranslation: boolean(),
    isProductReviewsWidgetEnabled: boolean(),
    isReviewTitleEnabled: boolean(),
    isReviewTitleRequired: boolean(),
    customerDisplayNamePolicy: union([
        literal(REVIEWER_NAME_DISPLAY_FORMAT.FULL_NAME),
        literal(REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_FULL_NAME),
        literal(REVIEWER_NAME_DISPLAY_FORMAT.SHORTEN_LAST_NAME),
        literal(REVIEWER_NAME_DISPLAY_FORMAT.ANONYMOUS),
        literal(REVIEWER_NAME_DISPLAY_FORMAT.CUSTOMER_CHOICE),
    ]),
    isReviewsVotingEnabled: boolean(),
    isReviewsPinningEnabled: boolean(),
    isReviewsTranslationEnabled: boolean(),
    defaultSortingOption: ReviewsSortingOptionsSchema,
    isReviewEditingEnabled: boolean(),

    // Transparency badges settings
    // TODO: remove default after deploy
    isVerifiedBuyerLabelEnabled: defaulted(boolean(), true),
    isVerifiedBuyerByMerchantLabelEnabled: defaulted(boolean(), true),
    isImportedLabelEnabled: defaulted(boolean(), true),
    isIncentivizedLabelEnabled: defaulted(boolean(), false),
    isReviewsIncentivizedLabelEnabled: defaulted(boolean(), false), // TODO: remove after deploy

    // Hidden settings
    isReviewsMediaEnabled: defaulted(boolean(), true),
    isUniteReviewsOriginProductEnabled: defaulted(boolean(), false),
});

export default ReviewsStorefrontValuesSettingsSchema;
